import angular from 'angular';

(function() {
    'use strict';
    angular.module('app.core').filter('bytes', bytesFilter);

    bytesFilter.$inject = ['$translate'];

    function bytesFilter($translate) {
        return function(bytes, precision) {
            if (bytes === 0) return bytes;
            if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return '-';
            if (typeof precision === 'undefined') precision = 1;
            var units = [
                    'units.data.bytes',
                    'units.data.kb',
                    'units.data.mb',
                    'units.data.gb',
                    'units.data.tb',
                    'units.data.pb'
                ],
                number = Math.floor(Math.log(bytes) / Math.log(1024));
            return (
                (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) +
                ' ' +
                $translate.instant(units[number])
            );
        };
    }
})();
